import { DataService } from "app/services/data.service";
import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';

@Component({
    selector: 'app-project-home',
    templateUrl: './project-home.component.html',
    styleUrls: ['./project-home.component.scss']
})
export class ProjectHomeComponent implements OnInit, OnDestroy {

    @ViewChild('header') header;

    constructor(
        public dataService: DataService,
    ) {
    }

    ngOnInit() {
        this.header.current_state_home = true;
    }

    ngOnDestroy() {
        this.header.current_state_home = false;
    }
}
